<template>
	<ul class="app-flex app-font-size-18 app-margin-top-45 message-container">
		<li :class="$route.meta.messageIndex == 1 ? 'notice-active' : 'notice'"><router-link to="/personal/message/notice">数网通知</router-link></li>
		<li :class="$route.meta.messageIndex == 2 ? 'announcement-active' : 'announcement'"><router-link to="/personal/message/announcement">数网公告</router-link></li>
		<li :class="$route.meta.messageIndex == 3 ? 'log-active' : 'log'"><router-link to="/personal/message/log">更新日志</router-link></li>
	</ul>
</template>

<script>
export default {
	name: 'PersonalMessageNavigate',
	data() {
		return {
			activeIndex: 1
		};
	},
	mounted() {
		this.activeIndex = this.$router.messageIndex;
	},
	methods: {}
};
</script>

<style lang="scss" scoped>
.message-container{
	li{
		// background-size:contain;
		background-repeat: no-repeat;
		background-position: 0 50%;
		padding-left:60px;
		line-height: 50px;
		
		a{
			color: #5D5D5D;
		}
	}
	.notice{
		background-image: url(../../../assets/2.0/megaphone-dynamic-premium.png);
	}
	.notice-active{
		background-image: url(../../../assets/2.0/megaphone-dynamic-premium.png);
		a{
			color: #ffffff;
		}
	}
	.announcement{
		margin-left: 30px;
		background-image: url(../../../assets/2.0/copy-front-premium.png);
	}
	.announcement-active{
		margin-left: 30px;
		background-image: url(../../../assets/2.0/copy-front-premium.png);
		a{
			color: #ffffff;
		}
	}
	
	.log{
		margin-left: 30px;
		background-image: url(../../../assets/2.0/bookmark-fav-front-premium.png);
	}
	.log-active{
		margin-left: 30px;
		background-image: url(../../../assets/2.0/bookmark-fav-front-premium.png);
		a{
			color: #ffffff;
		}
	}
}
</style>
